/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import clsx from "clsx";
import {BookingLoginReservationButtonStyle} from "types/enums/BookingLoginReservationButtonStyle";
import {useTranslation} from "react-i18next";
import {BookingLoginReservationButtonSize} from "types/enums/BookingLoginReservationButtonSize";

interface BookingLoginReservationButtonInnerProps {
    className?: string;
    label?: string;
    children?: React.ReactNode | React.ReactNode[];
    disabled?: boolean;
    style?: BookingLoginReservationButtonStyle;
    size?: BookingLoginReservationButtonSize;
    loading?: boolean;
}

const BookingLoginReservationButtonInnerLoading = () => {
    return (
        <svg className="animate-spin w-5 h-5 mr-1.5" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path
                className="opacity-75"
                d="M4 12a8 8 0 0 1 8-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 0 1 4 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                fill="currentColor"
            />
        </svg>
    );
};

const BookingLoginReservationButtonInner = (props: BookingLoginReservationButtonInnerProps) => {
    const {t} = useTranslation();
    return (
        <div
            className={clsx(
                "BookingLoginReservationButtonInner",
                // "rounded-md px-2 py-0.5 border active:bg-opacity-80 focus:bg-opacity-80 hover:bg-opacity-90 text-white inline-flex w-auto items-center text-center justify-center text-sm leading-6 font-bold cursor-pointer",
                "rounded-md border active:bg-opacity-80 focus:bg-opacity-80 hover:bg-opacity-90 inline-flex w-auto items-center text-center justify-center leading-6 font-bold ",

                props?.size === BookingLoginReservationButtonSize.Normal && "px-3 py-2 text-base",
                props?.size === BookingLoginReservationButtonSize.Large && "px-6 py-3 text-lg",
                // props?.size === BookingLoginReservationButtonSize.Small && "px-2 py-0.5 text-sm",
                props?.size === BookingLoginReservationButtonSize.Small && "px-2 py-1 text-sm",
                !props?.size && "px-3 py-2 text-lg",

                props?.style === BookingLoginReservationButtonStyle.Red && "border-red-400 bg-red-400 text-white",
                props?.style === BookingLoginReservationButtonStyle.Dark && "border-gray-700 bg-gray-700 text-white",
                props?.style === BookingLoginReservationButtonStyle.Gray && "border-gray-500 bg-gray-500 text-white",
                props?.style === BookingLoginReservationButtonStyle.Green && "border-green-400 bg-green-400 text-white",
                props?.style === BookingLoginReservationButtonStyle.Disabled && "border-green-400 bg-green-100 text-black",
                props?.style === BookingLoginReservationButtonStyle.DisabledBlack && "border-gray-300 bg-gray-300 text-black/40",
                props?.style === BookingLoginReservationButtonStyle.Blue && "border-blue-400 bg-blue-400 text-white",
                !props?.style && "border-blue-400 bg-blue-400 text-white",
                props.disabled && "cursor-not-allowed disabled:cursor-not-allowed",
                props?.className
            )}
        >
            {props.loading && <BookingLoginReservationButtonInnerLoading />}
            {props.label && <span>{t(props.label)}</span>}
            {props.children && props.children}
        </div>
    );
};

export default BookingLoginReservationButtonInner;
